<template>
  <div class="mb-10">
    <Stepper :model-value="currentStep" class="flex w-full items-start gap-2">
      <StepperItem
        v-for="item in steps"
        :key="item.step"
        :step="item.step"
        class="relative flex w-full flex-col items-center justify-center group"
      >
        <StepperTrigger class="cursor-default">
          <StepperIndicator
            class="transition-all duration-500 w-10 h-10"
            :class="[
              currentStep >= item.step
                ? 'bg-brand text-white shadow-[0_0_20px_rgba(255,95,0,0.3)] border-brand'
                : 'bg-white/5 text-text-weak-dark border-white/10',
            ]"
          >
            <component :is="item.icon" class="w-5 h-5" />
          </StepperIndicator>
        </StepperTrigger>

        <StepperSeparator
          v-if="item.step !== steps.length"
          class="absolute left-[calc(50%+24px)] right-[calc(-50%+12px)] top-5 block h-0.5 shrink-0 rounded-full transition-colors duration-500"
          :class="currentStep > item.step ? 'bg-brand' : 'bg-white/5'"
        />

        <div class="mt-3 flex flex-col items-center">
          <StepperTitle
            class="text-[10px] tracking-[0.15em] font-bold transition-colors"
            :class="
              currentStep >= item.step
                ? 'text-text-strong-dark'
                : 'text-text-weak-dark'
            "
          >
            {{ item.title }}
          </StepperTitle>
        </div>
      </StepperItem>
    </Stepper>
  </div>
</template>

<script setup lang="ts">
import {
  Stepper,
  StepperIndicator,
  StepperItem,
  StepperSeparator,
  StepperTitle,
  StepperTrigger,
} from "@/components/ui/stepper";

defineProps<{
  currentStep: number;
  steps: Array<{
    step: number;
    title: string;
    icon: any;
  }>;
}>();
</script>
